import Loadable from 'react-loadable';
import LoadingComponent from '../common/loader/index';

export default [
    {
        path: '/testPage',
        exact: true,
        component: Loadable({
            loader: () => import('./TestPage'),
            loading: LoadingComponent
        })
    },
    {
        path: '/testPage/:id',
        exact: true,
        component: Loadable({
            loader: () => import('./TestPage'),
            loading: LoadingComponent
        })
    }
    // {
    //     path: '/expiredToken',
    //     exact: true,
    //     component: Loadable({
    //         loader: () => import('../pages/loginContainer'),
    //         loading: LoadingComponent
    //     })
    // }
];
